import PropTypes from 'prop-types';

import styleSheet from './poll.module.scss';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for the poll hero
 *
 * @param {object} props poll option props
 * @param {object} props.poll poll option data
 * @param {boolean} props.isVisible - header hero visible, to decrease complexity of main components
 * @returns {Function} <PollHero />
 */
function PollHero({ poll, isVisible = true }) {
    const hasHeroImg = poll?.hero_image_url || poll?.hero_external_image_url;

    if (!hasHeroImg || !isVisible) {
        return null;
    }

    const renderHeroImage = () => {
        if (poll?.hero_image_url) {
            return (
                <img
                    part="potg-hero"
                    /* eslint-disable-next-line no-magic-numbers */
                    src={getImageUrl(poll.hero_image_url, 1784)}
                    alt={poll.hero_image_text || ''}
                    className={styles.pollHeroImage}
                    data-testid={'poll-hero-image-manual'}
                />
            );
        }

        if (poll?.hero_external_image_url) {
            return (
                <img
                    part="potg-hero"
                    src={poll.hero_external_image_url}
                    alt={poll.hero_image_text || ''}
                    className={styles.pollHeroImage}
                    data-testid={'poll-hero-image-automated'}
                />
            );
        }

        return null;
    };

    /* eslint-disable no-magic-numbers */
    return (
        <div
            data-cy="heroLabel"
            className={styles.pollHero}
            data-testid="poll-hero"
        >
            {renderHeroImage()}
        </div>
    );
}

PollHero.propTypes = {
    poll: PropTypes.object.isRequired,
    isVisible: PropTypes.bool
};

export default PollHero;
